import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as expandableSectionActions from '~/actions/expandableSection';
type ExpandableSectionProps = {
  actions: object;
  expandableSectionState: object;
  minHeightClass?: string;
  collapsedHeightClass?: string;
  isExpandedByDefault?: boolean;
  id?: string;
};
class ExpandableSection extends React.Component<ExpandableSectionProps, {}> {
  toggleSection = section => {
    const { expandableSectionState = {}, isExpandedByDefault = true } = this.props;
    const { [section]: isExpanded = isExpandedByDefault } = expandableSectionState;
    if (isExpanded) {
      this.props.actions.collapseSection(section);
    } else {
      this.props.actions.expandSection(section);
    }
  };
  render() {
    const {
      expandableSectionState = {},
      id,
      children,
      isExpandedByDefault = true,
      minHeightClass = 'min-height--205',
      collapsedHeightClass = 'height--300',
    } = this.props;
    const { [id]: isExpanded = isExpandedByDefault } = expandableSectionState;
    return (
      <section>
        <div
          className={
            isExpanded ? `${minHeightClass}` : `${collapsedHeightClass} overflow-y--hidden`
          }
        >
          {children}
        </div>

        <div
          className={`${
            isExpanded ? 'mt' : ''
          } bg-color--white-dark color--primary text--center text--bold p- cursor--pointer`}
          onClick={() => this.toggleSection(id)}
        >
          {isExpanded ? 'Read less' : 'Read more'}
        </div>
      </section>
    );
  }
}
function mapStateToProps(state) {
  return {
    expandableSectionState: state.expandableSectionState,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(expandableSectionActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExpandableSection);
